import './../../external/@lit/reactive-element/reactive-element.js';
import './../../external/lit-html/lit-html.js';
import './../../external/lit-element/lit-element.js';
import { css as i } from './../../external/@lit/reactive-element/css-tag.js';
var CardCss = i`
  :host {
    font-family: var(--isceco-font);
    display: block;
    color: var(--isceco-color-black-500);
    box-shadow: 0 1px 4px 0 #0000001F;
    border-radius: 4px;
    background-color: var(--isceco-color-white-500);
    padding: var(--isceco-space-300);
  }
  
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: var(--isceco-space-300);
  }

  .header-text-wrapper {
    display: flex;
    align-items: center;
  }

  .header-text-wrapper > isceco-popup {
      margin-left: 0.2rem;
  }
  
  .header-text {
    font-weight: bold;
    font-size: 1.25rem;
  }
  
  .header > isceco-popup {
    margin-left: 0.2rem;
  }
`;
export { CardCss as default };
